import ButtonFunction from "./shared/ButtonFunction";
import TextInputHorizontalTag from "./shared/TextInputHorizontalTag";
import NavLabel from "./shared/NavLabel";
import GeneralContext from "../context/GeneralContext";
import { useContext, useEffect, useState } from "react";
import {fetchBody} from '../utils/fetch';

function PassIdCard() {

    const { changeActiveMode, changeModalTitle, changeModalText, changeModalType, setActivePasswordDocument, setActivePasswordQuestion, setDelayTimer } = useContext(GeneralContext);

    const [documentId, setDocumentId] = useState("");
    const changeDocumentId = (e) => {
        setDocumentId(e.target.value);
    }
    
    const loginMode = () => {
        changeActiveMode('login');
    }

    useEffect(() => {
      setDelayTimer(1);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const passIdFunction = async () => {
        const modal = document.getElementById("myModal");
        if (documentId === '') {
            changeModalTitle('Error');
            changeModalText('El documento no puede estar vacío');
            changeModalType('alert');
            modal.style.display = "block";
        } else {
            const data = {document: documentId};
            const response = await fetchBody('security_question', 'POST', data);
            if (response.success) {
                setActivePasswordDocument(documentId);
                setActivePasswordQuestion(response.question);
                changeActiveMode('question');
            } else {
                changeModalTitle('Error al intentar la operación');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        }
    }   

  return (
    <div id='loginCard'>
      <>
        <h2>Recuperación de contraseña</h2>
        <TextInputHorizontalTag label='Documento' changeEvent={changeDocumentId}/>
        <br />
        <ButtonFunction buttonClass='loginButton' buttonFunction={passIdFunction}>Continuar</ButtonFunction>
        <br />
        <br />
        <NavLabel navFunction={loginMode}>Regresar a ingreso</NavLabel>
      </>
    </div>
  )
}

export default PassIdCard